export const CORS_BYPASS: string = "https://cors-anywhere.herokuapp.com/";
// dev url
//export const BASE_API_URL = "https://dev-api-v3.ezcloud123.io";
// Environment variables configured via GitHub Actions workflow
//export const BASE_API_URL = "https://nfs8gfkn8a.execute-api.us-east-1.amazonaws.com/dev/";
// live url
//export const BASE_API_URL = "https://apiv3.ezcloud.co";
//trail url
// export const BASE_API_URL = " https://trial-apiv3.ezcloud.co/";
//test url
// Now using environment variable with dev-api-v4 URL as fallback
export const BASE_API_URL: string =
  import.meta.env.VITE_API_DEV_URL ||
  import.meta.env.VITE_API_V3_URL ||
  "https://dev-api-v4.ezcloudai.co";

// Enterprise API migration: the new NestJS REST API root (/api/v1). Critical-path endpoint
// constants point here with REST paths; not-yet-migrated constants stay on BASE_API_URL.
export const API_V1_BASE: string =
  import.meta.env.VITE_API_V1_URL ||
  (import.meta.env.VITE_API_DEV_URL ? `${import.meta.env.VITE_API_DEV_URL}/api/v1` : "/api/v1");

export const LOGIN_URL: string = API_V1_BASE + "/auth/login";
export const CREATE_CUSTOMER: string = API_V1_BASE + "/onboarding/customer";
export const CREATE_PREMIUM_CUSTOMER: string = API_V1_BASE + "/onboarding/premium-customer";
// M12: create member -> POST /admin/users {email,firstName,lastName,password,roleId};
// update member -> PATCH /admin/users/:id {firstName,lastName,roleId} (call site appends /:id).
export const CREATE_TEAM_USER: string = API_V1_BASE + "/admin/users";
// Enterprise API: invoice list migrated to GET /api/v1/invoices. The new endpoint accepts the same
// v4 query params (offset/count/status/name/invoiceNumber/fromAmount/toAmount/invCreatedDate) and the
// response interceptor normalizes its envelope (count/statusCount/totalCount), so call sites are
// unchanged. See API status-projection for the status-string mapping.
export const GET_INVOICE_LIST: string = API_V1_BASE + "/invoices";
// Team roster (M12): member-accessible list — team management + member pickers/@mentions.
// Returns data[] of {userId(ULID), firstName, lastName, email, userRole, isActive} + count.
export const GET_USERS: string = API_V1_BASE + "/team/members";
// M12 team details — v4-shaped { data:[{companyName,autoApproval,companyLogo,invoiceSenderEmail,
// supplierMaintenanceEmail,isAutoApproval,confidentLevel,supplier:{ach}}] }. Update is PUT.
export const GET_TEAMDETAILS_BY_ID: string = API_V1_BASE + "/team/details";
export const FORGET_PASSWORD: string = API_V1_BASE + "/auth/secondary/forgot-password";
export const UPDATE_PASSWORD: string = API_V1_BASE + "/auth/secondary/update-password";
// M12: current-user profile (self) — v4 array shape data[0]={userId,email,firstName,lastName,
// userRole,...lean-empty}. The FE always passes its own id; the API resolves self from the JWT.
export const GET_USER_BY_ID: string = API_V1_BASE + "/users/me/details";
// G-PROFILE-01: self-profile edit (GeneralProfile/EditProfile) — PATCH, lean enterprise name
// fields only (firstName/lastName/displayName; phone/photo/approval amounts intentionally not
// stored, see TESTING-READINESS). Admin member edit uses CREATE_TEAM_USER (/admin/users) + /:id
// directly (see AddUpdateteam).
export const UPDATE_SELF_PROFILE: string = API_V1_BASE + "/users/me/profile";
// G-SUBSUPPLIER-01 CLOSED (V071 SUPPLIER_USER): portal sub-users live on the supplier-portal
// module. List/create on the collection; edit (names, active toggle) on the member resource.
// The legacy /user/updateUser + /user/createTeamUser constants are deleted (dead since wave 2).
export const SUB_SUPPLIERS: string = API_V1_BASE + "/supplier-portal/sub-users";
export const SUB_SUPPLIER_BY_ID = (id: string | number): string =>
  `${API_V1_BASE}/supplier-portal/sub-users/${id}`;
export const UPDATE_TEAM: string = API_V1_BASE + "/team/details";
export const UPDATE_SUPPLIER_ACH: string = API_V1_BASE + "/supplier-portal/ach";
// G-UPLOAD-01: UPLOAD_FILE (/uploadFile/uploadFile, the legacy byte-proxy) is GONE — all asset
// uploads (company logo, supplier documents) now use the enterprise presign 2-step via
// services/storageAssetService.ts (PRE_SIGNED_URL -> PUT -> persist storageUri; display resolves
// through ACCESS_S3_FILE). Profile photo upload is intentionally dropped (lean user model, M14).
// Enterprise API: invoice detail + lines are REST path-param endpoints (id in the path, not a query
// param). Builders so call sites pass the id. The response interceptor wraps the single detail object
// into a 1-element array so existing `data[0]` consumers stay unchanged (see constants/API.ts).
export const GET_INVOICE_DETAILS = (id: string | number): string => `${API_V1_BASE}/invoices/${id}`;
// Enterprise API: overview widget — GET /dashboard/overview -> flat { status, invoiceAnalysis,
// receivedInvoices, hourByPending }. (hourByPending deferred -> []; date-range filtering deferred.)
export const DASHBOARD_OVERVIEW: string = API_V1_BASE + "/dashboard/overview";
export const DASHBOARD_DAILYREPORT: string = API_V1_BASE + "/dashboard/daily-report";
export const DASHBOARD_SUPPLIER_STATISTICS: string = API_V1_BASE + "/dashboard/supplier-statistics";
export const DASHBOARD_WEEKLY_REPORT: string = API_V1_BASE + "/dashboard/weekly-report";
export const DASHBOARD_INVOICE_STATISTICS: string = API_V1_BASE + "/dashboard/invoice-statistics";
export const DASHBOARD_TEAM_STATISTICS: string = API_V1_BASE + "/dashboard/team-statistics";
export const DASHBOARD_INVOICE_DISTRIBUTION: string =
  API_V1_BASE + "/dashboard/invoice-distribution";
export const DASHBOARD_APPROVAL_DISTRIBUTION: string =
  API_V1_BASE + "/dashboard/approval-distribution";
// Enterprise API: header edit via PATCH /invoices/:id { invoiceNumber?, invoiceDate?, dueDate?,
// currencyCode? } (changed fields; amounts are line-derived). Lock-gated (assertEditable).
export const UPDATE_INVOICE = (id: string | number): string => `${API_V1_BASE}/invoices/${id}`;
// Enterprise API: status change via POST /invoices/:id/status { status: <enterprise code>, note? }.
// FE maps its display string to the code with toApiStatusCode (common/statusCode).
export const UPDATE_INVOICE_STATUS = (id: string | number): string =>
  `${API_V1_BASE}/invoices/${id}/status`;
// [UAT-R1 Finding 1] Enterprise API: persist the PO / Non-PO radio (v4 /invoice/updatePoFlag).
// POST { isPo: 0|1 } — fires immediately on toggle, no lock/edit-mode required (legacy parity).
export const UPDATE_PO_FLAG = (id: string | number): string =>
  `${API_V1_BASE}/invoices/${id}/po-flag`;
// Enterprise API: presigned (OCI PAR) URL for a stored object by key. POST { filePath } -> flat
// { status, url } (the v4 ACCESS_S3_FILE contract the preview call sites read). Tenant-scoped by key.
export const ACCESS_S3_FILE: string = API_V1_BASE + "/documents/access";
export const TEAM_MEMBER_ASSIGN: string = API_V1_BASE + "/supplier-assignment/assign";
export const GET_ASSIGNER_LIST: string = API_V1_BASE + "/supplier-assignment/assigners";
export const GET_ASSIGNED_TEAM_LIST: string = API_V1_BASE + "/supplier-assignment/assignments";

// Enterprise API: bulk replace lines via POST /invoices/:id/lines/save { lines: LineDto[] }.
export const SAVE_INVOICE_LINE_ITEMS = (id: string | number): string =>
  `${API_V1_BASE}/invoices/${id}/lines/save`;

//Notification

export const SAVE_DEVICE: string = API_V1_BASE + "/devices/save";
export const DELETE_DEVICE: string = API_V1_BASE + "/devices/delete";
// G-NOTIF-01: legacy saveNotificationDetails was both "mark read" and "client-create"; the
// enterprise API only exposes mark-read (creation is server-side, e.g. workflow submit/advance).
export const MARK_NOTIFICATION_READ_URL = (id: string | number): string =>
  `${API_V1_BASE}/notifications/${id}/read`;
export const MARK_ALL_NOTIFICATIONS_READ_URL: string = API_V1_BASE + "/notifications/read-all";

//upload url for dev
//export const REUPLOAD_URL =
// "https://to77qk4lxa.execute-api.us-east-1.amazonaws.com/GetStartedLambdaProxyIntegration";
// upload url for live
// export const REUPLOAD_URL =
//   "https://kzewnk2xf5.execute-api.us-east-1.amazonaws.com/default/ezcloud-file-upload-handler";
//trail url
// export const REUPLOAD_URL =
// "https://6b7t38qpn0.execute-api.us-east-1.amazonaws.com/default/ezcloud-file-upload-handler";

//upload url — v4 native reupload endpoint (same for all environments)
// Enterprise API: upload ingest (step 2) — create invoice (RECEIVED) + its PDF doc from the uploaded
// object. Body { storageUri, fileName, contentType?, source? } -> { success, invoiceId }.
export const REUPLOAD_URL: string = API_V1_BASE + "/invoices/ingest";

//export const REUPLOAD_URL =
//"https://kzewnk2xf5.execute-api.us-east-1.amazonaws.com/default/ezcloud-file-upload-handler";

export const VERIFY_EMAIL_URL: string = API_V1_BASE + "/onboarding/verify-email";
// G-NAV-01: NEXT_INVOICE_URL (/invoice/getNextInvoice) removed — the successor is derived
// client-side from GET /invoices (see services/nextInvoiceService.ts); no enterprise endpoint needed.
// Enterprise API: line items via GET /invoices/:id/lines (returns data as an array, like v4).
export const INVOICE_LINE_LISTING = (id: string | number): string =>
  `${API_V1_BASE}/invoices/${id}/lines`;
export const GET_TABLE_VALUES_BY_ID: string = API_V1_BASE + "/extraction-config/table-values";
// Enterprise API: line items are REST sub-resources of the invoice.
export const INVOICELINE_CREATE_URL = (id: string | number): string =>
  `${API_V1_BASE}/invoices/${id}/lines`;
export const INVOICE_LINE_DELETE_URL = (id: string | number, lineId: string | number): string =>
  `${API_V1_BASE}/invoices/${id}/lines/${lineId}`;
export const INVOICE_LINE_UPDATE_URL = (id: string | number, lineId: string | number): string =>
  `${API_V1_BASE}/invoices/${id}/lines/${lineId}`;
// Enterprise API: lock/unlock are POST /invoices/:id/lock|unlock (no body). lock() 409s if another
// user holds the lock (the FE catch handles it; the old data.lockedUserId branch is now inert).
export const LOCK_INVOICE_URL = (id: string | number): string =>
  `${API_V1_BASE}/invoices/${id}/lock`;
export const UNLOCK_INVOICE_URL = (id: string | number): string =>
  `${API_V1_BASE}/invoices/${id}/unlock`;
export const GET_LOCKED_INVOICES_URL: string = API_V1_BASE + "/locked-invoices";
export const GET_INVOICE_FIELDS: string = API_V1_BASE + "/extraction-config/invoice-fields";
export const GET_KEYVALUES_BY_SUPPLIERNAME: string =
  API_V1_BASE + "/extraction-config/keyvalues-by-supplier";
export const UPDATE_INVOICE_FIELDS: string = API_V1_BASE + "/extraction-config/invoice-fields";
// [UAT-R23-ADM F3] Add New Field — creates a real custom field definition (was UI-only in v4).
export const CREATE_INVOICE_FIELD: string =
  API_V1_BASE + "/extraction-config/invoice-fields/custom";
export const GENERATE_OTP: string = API_V1_BASE + "/auth/secondary/generate-otp";
export const VERIFY_OTP: string = API_V1_BASE + "/auth/secondary/verify-otp";

export const UPDATE_SUPPLIER_STATUS: string = API_V1_BASE + "/supplier-portal/request-status";

export const SUPPLIER_LISTING: string = API_V1_BASE + "/supplier-portal/requests";
export const SUPPLIER_SITE_LISTING: string = API_V1_BASE + "/supplier-portal/sites";
export const SUPPLIER_LISTING_RECLASIFICATION: string =
  API_V1_BASE + "/supplier-portal/reclassifications";

export const ADD_SUPPLIER_REQUEST_URL: string = API_V1_BASE + "/supplier-portal/requests";
export const ADD_SUPPLIER_SITE_URL: string = API_V1_BASE + "/supplier-portal/sites";

export const USER_SIGN_OUT_URL: string = API_V1_BASE + "/auth/logout"; // M15: stateless logout
// G-EMAILLIST-01: the email-recipient picker reads the enterprise team roster — call sites go
// through services/teamRosterService.ts (GET_USERS = /team/members) with a shape adapter; the
// legacy /user/getEntityUser constant is gone.
export const NOTIFY_SUPPLIER_URL: string = API_V1_BASE + "/supplier-portal/notify-supplier";

// G-NOTIFWRITE-01: notify-approver now lands on the notifications module, which creates the
// in-app bell event server-side for each (tenant-validated) approver email; the email leg stays
// stubbed (G-EMAIL-01). Was the supplier-portal stub that returned sent:false without any event.
export const NOTIFY_APPROVER_URL: string = API_V1_BASE + "/notifications/notify-approver";

export const UPDATE_SUPPLIER_REQUEST_URL: string = API_V1_BASE + "/supplier-portal/request-update";

export const UPDATE_SUPPLIER_SITE_URL: string = API_V1_BASE + "/supplier-portal/sites";

// Enterprise API: upload presign (step 1) — presigned OCI PUT URL for a new upload. Body { name, type }
// -> { status, url, storageUri }. The client PUTs the file to `url`, then passes storageUri to ingest.
export const PRE_SIGNED_URL: string = API_V1_BASE + "/invoices/upload-url";
// [UAT-PROFILE] tenant-asset presign (profile photos) — same contract as PRE_SIGNED_URL but the
// key lands under tenants/<tenant>/assets/<user>/ (no invoice, no INVOICE_UPLOAD gate).
export const ASSET_PRE_SIGNED_URL: string = API_V1_BASE + "/assets/upload-url";
// M12: deactivate/reactivate a member -> PATCH /admin/users/:id/active. Call site appends /:id/active.
// (Sub-supplier delete in SubSupplierTable is portal/M10c — that path is deferred.)
export const DELETE_TEAM_MEMBER: string = API_V1_BASE + "/admin/users";
// Enterprise API: "complete exception" resolves all open exceptions via POST /invoices/:id/exceptions/
// resolve (no body). Clearing them drops the invoice off the exception queue (exceptions are orthogonal
// to status). The resolution comment is a minor deferred fidelity item.
export const UPDATE_EXCEPTION_STATUS = (id: string | number): string =>
  `${API_V1_BASE}/invoices/${id}/exceptions/resolve`;

export const SUPPLIER_RECLARIFICATION: string = API_V1_BASE + "/supplier-portal/reclassifications";

//report
export const REPORT_URL: string = API_V1_BASE + "/reports/invoice-address";
export const INVOICE_REPORT_URL: string = API_V1_BASE + "/reports/invoice";
export const TEAM_REPORT_URL: string = API_V1_BASE + "/reports/team";
export const SUPPLIER_REPORT_URL: string = API_V1_BASE + "/reports/supplier";
export const STANDARD_DEVIATION_URL: string = API_V1_BASE + "/reports/amount-metrics";
export const MONTH_WISE_DEVIATION_URL: string = API_V1_BASE + "/reports/received-metrics";
export const ROUNDED_INVOICES_URL: string = API_V1_BASE + "/reports/rounded-metrics";
//Comment

// Enterprise API: comments live under the invoice (list/add) and by comment id (get/edit/delete).
// add/edit body = CommentDto { body }. List items map to the v4 ChatComment shape at the call site.
export const CREATE_COMMENT_URL = (invoiceId: string | number): string =>
  `${API_V1_BASE}/invoices/${invoiceId}/comments`;
export const COMMENT_LIST_URL = (invoiceId: string | number): string =>
  `${API_V1_BASE}/invoices/${invoiceId}/comments`;
export const UPDATE_COMMENT_URL = (commentId: string | number): string =>
  `${API_V1_BASE}/comments/${commentId}`;
export const DELETE_COMMENT_URL = (commentId: string | number): string =>
  `${API_V1_BASE}/comments/${commentId}`;
export const COMMENT_BY_ID_URL = (commentId: string | number): string =>
  `${API_V1_BASE}/comments/${commentId}`;
// G-MENTIONS-01: the @mention dropdown reads the enterprise team roster — ChatSection goes through
// services/teamRosterService.ts (GET_USERS = /team/members, member-accessible) with a shape
// adapter; the legacy /comment/getChatUser constant is gone.
//audits
export const GET_AUDIT_URL: string = API_V1_BASE + "/extraction-config/audits";
export const SAVE_AUDIT: string = API_V1_BASE + "/extraction-config/audits";
export const UPDATE_INV_PROCESS_TIME: string = API_V1_BASE + "/extraction-config/processing-time";

export const IS_NEW_USER_URL: string = API_V1_BASE + "/onboarding/is-new-user";

export const FORMAT_SETTING_URL: string = API_V1_BASE + "/extraction-config/format-setting";
export const GET_FORMAT_SETTING_URL: string = API_V1_BASE + "/extraction-config/format-setting";

//Cron — G-CRON-01: enterprise cron-export module (doc 22 §5 D3). Save/update are one
// idempotent PUT /cron/schedule upsert; history is GET /cron/exports; instant export is
// POST /cron/export -> CSV in OCI Object Storage + presigned download (the legacy
// /crone/getInstantExport had NO AUTH and emailed the CSV — never ported). All calls go
// through services/cronExportService.ts (shape adapter).
export const SAVE_CRON_DETAILS: string = API_V1_BASE + "/cron/schedule";
export const UPDATE_CRON_DETAILS: string = API_V1_BASE + "/cron/schedule";
export const GET_CRONE_DETAILS: string = API_V1_BASE + "/cron/schedule";
export const GET_EXPORTED_LIST: string = API_V1_BASE + "/cron/exports";
export const GET_INSTANT_EXPORT: string = API_V1_BASE + "/cron/export";

//new extraction
export const EXTRACTION_FORM_URL: string = API_V1_BASE + "/extraction-config/extraction-form";
export const TRAINING_DATASET_URL: string = API_V1_BASE + "/extraction-config/training-dataset";

// Training data storage URL — the one canonical training-save endpoint.
// SAVE_TRAINING_DATASET_URL was removed 2026-04-25 after it was identified
// as an alias creating duplicate save calls — see
// docs/TRAINING-DATA-DATASETTYPE-FIX-DESIGN.md.
// [G-TRAINING-01] 2026-06-10: repointed from legacy /entityDataset/saveEntityTrainingDataset to
// the enterprise extraction-feedback save (M23 extraction-config; corrections also feed the
// wave-3 supplier hints). Same payload shape ({ invoiceId, entityDatasetDetails }), but invoiceId
// is the ULID string now (call sites send String(invoiceID), not parseInt). Still exactly ONE
// save per user action — do not add sibling save calls.
export const TRAINING_DATA_STORAGE_URL: string =
  import.meta.env.VITE_TRAINING_DATA_STORAGE_URL ||
  API_V1_BASE + "/extraction-config/training-dataset";

// Get saved training data by supplier name
export const GET_TRAINING_BY_SUPPLIER_URL: string =
  API_V1_BASE + "/extraction-config/training-by-supplier";

//resubmit
// Now using environment variable with pretest URL as fallback
// Enterprise API: re-queue for extraction via POST /invoices/:id/reprocess (no body).
export const RESUBMIT_INITIALIZED_INVOICE_URL = (id: string | number): string =>
  `${API_V1_BASE}/invoices/${id}/reprocess`;

export const GET_TRAINED_DATASET_URL: string = API_V1_BASE + "/extraction-config/trained-dataset";

// Supplier picker dropdown source (M10): full active-supplier list as data[].supplierName.
export const GET_SUPPLIER_LIST_URL: string = API_V1_BASE + "/suppliers/options";

export const GET_SUPPLIER_LIST: string = API_V1_BASE + "/suppliers/options";

export const GET_EXCEPTION_HANDLER_ROLE_URL: string =
  API_V1_BASE + "/invoices/exceptions/handler-role";

export const GET_EXCEPTION_HANDLER_DETAILS: string =
  API_V1_BASE + "/invoices/exceptions/handler-details";

// M05b: raise exception -> POST /invoices/:id/exceptions (call site appends /:id/exceptions).
export const SAVE_INVOICE_EXCEPTION: string = API_V1_BASE + "/invoices";

// Enterprise API: the exception queue is the invoice list filtered to open exceptions — same endpoint,
// same row/statusCount/totalCount shape, plus hasException=true (added at the call sites). Role-based
// "my exceptions" filtering (the v4 userId param) is the deferred exception-handler-role feature.
export const GET_INVOICE_EXCEPTION_LIST: string = API_V1_BASE + "/invoices";

export const IMPORT_GLCODE: string = API_V1_BASE + "/gl-segments/gl-codes";

export const GET_TAG_VALUE: string = API_V1_BASE + "/gl-segments/tag-values";

export const SAVE_GLCODE_TAGVALUE: string = API_V1_BASE + "/gl-segments/assignments";

export const GET_ASSIGNED_GLCODE_VALUE: string = API_V1_BASE + "/gl-segments/assignments";

export const DELETE_GLCODE: string = API_V1_BASE + "/gl-segments/gl-codes";

// GL Segments
export const GL_SEGMENT_CONFIG: string = API_V1_BASE + "/gl-segments/config";
export const GL_SEGMENT_VALUES: string = API_V1_BASE + "/gl-segments/values";
// Tax Region
// Enterprise API: tax-region config CRUD (GET/PUT config, PUT tax-type, DELETE tax-type/:id, POST preset).
export const TAX_REGION_CONFIG: string = API_V1_BASE + "/tax-region/config";
export const TAX_REGION_TAX_TYPE: string = API_V1_BASE + "/tax-region/tax-type"; // DELETE appends /:taxTypeId
export const TAX_REGION_PRESET: string = API_V1_BASE + "/tax-region/preset";
// G-TAXREGION-01: per-invoice tax detail on the enterprise tax-region module —
// GET ?invoiceId=<invoice PUBLIC_ID> -> rows {taxTypeCode,taxAmount,taxRate,registrationNumber,...};
// PUT {invoiceId,taxTypeCode,taxAmount?,taxRate?} upserts an INVOICE_TAX_LINE row.
export const TAX_REGION_INVOICE: string = API_V1_BASE + "/tax-region/invoice";
export const VALIDATE_TWO_FACTOR_AUTH: string = API_V1_BASE + "/auth/secondary/2fa/verify";
export const FORGET_TWO_FACTOR_AUTH: string = API_V1_BASE + "/auth/secondary/2fa/forget";
export const RESEND_EMAIL: string = API_V1_BASE + "/supplier-portal/request-resend";
export const UPDATE_TWOFAAUTHENTICATION: string = API_V1_BASE + "/auth/secondary/2fa/update";

// G-NAV-01: EXCEPTION_NEXT_INVOICE_URL (/team/getNextExceptionInvoice) removed — the successor is
// derived client-side from GET /invoices?hasException=true (see services/nextInvoiceService.ts).
// G-CRON-01: ERP flag now lives on the export-history row — PATCH /cron/exports/:exportId
// { isErp } (cronExportService.updateExportIsErp appends the id).
export const UPDATE_IS_ERP: string = API_V1_BASE + "/cron/exports";

// G-NOTIF-01: enterprise notifications (self-scoped via JWT; legacy userId param dropped).
export const GET_NOTIFICATION_URL: string = API_V1_BASE + "/notifications";

//Non-Duplicate
// Enterprise API: resolve duplicate via POST /invoices/:id/non-duplicate (no body).
export const NON_DUPLICATE_URL = (id: string | number): string =>
  `${API_V1_BASE}/invoices/${id}/non-duplicate`;

// Expense Module — Phase 1
export const EXPENSE_CLAIMS: string = API_V1_BASE + "/expense/claims";
export const EXPENSE_CLAIMS_MINE: string = API_V1_BASE + "/expense/claims/mine";
export const EXPENSE_CLAIMS_PENDING: string = API_V1_BASE + "/expense/claims/pending-approval";
export const expenseClaimByIdUrl = (id: number): string => `${API_V1_BASE}/expense/claims/${id}`;
export const expenseClaimSubmitUrl = (id: number): string =>
  `${API_V1_BASE}/expense/claims/${id}/submit`;
export const expenseClaimApproveUrl = (id: number): string =>
  `${API_V1_BASE}/expense/claims/${id}/approve`;
export const expenseClaimRejectUrl = (id: number): string =>
  `${API_V1_BASE}/expense/claims/${id}/reject`;
export const expenseClaimCommentUrl = (id: number): string =>
  `${API_V1_BASE}/expense/claims/${id}/comment`;
export const expenseClaimReimburseUrl = (id: number): string =>
  `${API_V1_BASE}/expense/claims/${id}/reimburse`;
export const expenseReceiptsUrl = (id: number): string =>
  `${API_V1_BASE}/expense/claims/${id}/receipts`;
export const expenseReceiptByIdUrl = (cid: number, rid: number): string =>
  `${API_V1_BASE}/expense/claims/${cid}/receipts/${rid}`;
export const expenseReceiptOcrUrl = (cid: number, rid: number): string =>
  `${API_V1_BASE}/expense/claims/${cid}/receipts/${rid}/ocr`;
export const expenseAuditUrl = (id: number): string => `${API_V1_BASE}/expense/claims/${id}/audit`;
export const EXPENSE_CATEGORIES: string = API_V1_BASE + "/expense/categories";

// EBS / ERP Supplier Sync
export const SUPPLIER_SYNC_TRIGGER_URL: string = API_V1_BASE + "/supplier-sync/trigger";
export const SUPPLIER_SYNC_UPLOAD_URL: string = API_V1_BASE + "/supplier-sync/upload";
export const SUPPLIER_SYNC_STATUS_URL: string = API_V1_BASE + "/supplier-sync/status"; // M21 (maps)
export const SUPPLIER_SYNC_HISTORY_URL: string = API_V1_BASE + "/supplier-sync/history";
export const SUPPLIER_SYNC_SUPPLIERS_URL: string = API_V1_BASE + "/supplier-sync/suppliers";
export const SUPPLIER_SYNC_SITES_URL: string = API_V1_BASE + "/supplier-sync/sites";
export const SUPPLIER_SYNC_CONFIG_URL: string = API_V1_BASE + "/supplier-sync/config"; // M21 (maps; rest of sync engine net-new)
export const SEARCH_EBS_SUPPLIERS_URL: string = API_V1_BASE + "/supplier-sync/suppliers/search";
// Alias used by OIC Sync components (same endpoint as SEARCH_EBS_SUPPLIERS_URL)
export const SEARCH_ERP_SUPPLIERS_URL: string = API_V1_BASE + "/supplier-sync/suppliers/search";
export const GET_EBS_SUPPLIER_SITES_BY_NAME_URL: string =
  API_V1_BASE + "/supplier-sync/suppliers/byName/sites";
// Alias used by OIC Sync components (same endpoint as GET_EBS_SUPPLIER_SITES_BY_NAME_URL)
export const GET_ERP_SUPPLIER_SITES_BY_NAME_URL: string =
  API_V1_BASE + "/supplier-sync/suppliers/byName/sites";
export const RESOLVE_ABN_URL: string = API_V1_BASE + "/supplier-sync/suppliers/resolveABN";

// OIC Invoice Export — G-OIC-01 / decision D2 (doc 22 §5): STUB-ACCEPT. The OIC export pipeline is
// customer-specific (Barwon -> Oracle Fusion Cloud ERP via OIC + SFTP polling) and is NOT ported to
// the enterprise API by decision — no /oicExport/* routes exist on the new host. The future
// implementation re-targets the SpringBoot integration layer (doc 21), not a Node port. These
// constants are intentionally left legacy-pointed but are NEVER fetched: InvoiceExportSettings is
// a flag-gated honest stub (oicExportEnabled OFF in dev tenants hides the tab entirely; ON renders
// a "requires Oracle Fusion integration" state with all fetches/actions short-circuited).
export const OIC_EXPORT_TRIGGER_URL: string = BASE_API_URL + "/oicExport/trigger";
export const OIC_EXPORT_POLL_URL: string = BASE_API_URL + "/oicExport/pollResponses";
export const OIC_EXPORT_STATUS_URL: string = BASE_API_URL + "/oicExport/status";
export const OIC_EXPORT_HISTORY_URL: string = BASE_API_URL + "/oicExport/history";
export const OIC_EXPORT_REQUEUE_URL: string = BASE_API_URL + "/oicExport/requeue";

// Supplier Documents (HACOV)
export const ADD_SUPPLIER_DOCUMENT: string = API_V1_BASE + "/supplier-portal/documents";
export const GET_SUPPLIER_DOCUMENTS: string = API_V1_BASE + "/supplier-portal/documents";
export const RENAME_SUPPLIER_DOCUMENT: string = API_V1_BASE + "/supplier-portal/documents/rename";
export const DELETE_SUPPLIER_DOCUMENT: string = API_V1_BASE + "/supplier-portal/documents";

// Yardi Integration (HACOV)
export const YARDI_DETAILS: string = API_V1_BASE + "/yardi/details";
export const ALLOWED_CASH_AMOUNT: string = API_V1_BASE + "/yardi/allowed-cash-account";
export const GET_EXPENSE_ACCOUNT: string = API_V1_BASE + "/yardi/expense-account";

// Feature Flags (M12) — GET /team/feature-flags returns the tenant flag set; FE merges over defaults.
export const GET_FEATURE_FLAGS_URL: string = API_V1_BASE + "/team/feature-flags";

// Language / i18n
export const GET_AVAILABLE_LANGUAGES_URL: string = API_V1_BASE + "/self-service/languages";
export const UPDATE_LANGUAGE_SETTINGS_URL: string = API_V1_BASE + "/self-service/language-settings";
export const UPDATE_LANGUAGE_PREFERENCE_URL: string =
  API_V1_BASE + "/self-service/language-preference";

// SSO (M18) — config + AD-group mappings + the live OIDC flow all map to the enterprise /sso/*.
export const SSO_CHECK_URL: string = API_V1_BASE + "/sso/check";
export const SSO_CONFIG_URL: string = API_V1_BASE + "/sso/config";
export const SSO_AD_GROUPS_URL: string = API_V1_BASE + "/sso/adGroups";
export const SSO_AUTHORIZE_URL: string = API_V1_BASE + "/sso/authorize";
// test-connection has no enterprise route yet — kept on the enterprise base so it 404s harmlessly.
export const SSO_TEST_URL: string = API_V1_BASE + "/sso/test";

// Permissions (M13) — enterprise is role-based: catalog/roles/user-effective-perms + role change
// map to /admin/*. permissionService adapts shapes + builds the :id path params.
export const GET_PERMISSION_CATALOG_URL: string = API_V1_BASE + "/admin/permissions";
export const GET_ROLES_URL: string = API_V1_BASE + "/admin/roles";
export const GET_USER_PERMISSIONS_URL: string = API_V1_BASE + "/admin/users"; // + /:id/permissions
export const UPDATE_USER_ROLE_URL: string = API_V1_BASE + "/admin/users"; // + /:id/role (PATCH)
// NET-NEW (no enterprise schema — strictly role-based): per-user permission overrides + permission
// sets aren't modeled. Left on v4; deferred to M13b (decision: build USER_PERMISSION/PERMISSION_SET
// tables vs role-only model). The AddUpdateteam per-user permission checkboxes depend on this.
export const UPDATE_USER_PERMISSIONS_URL: string = API_V1_BASE + "/admin/users/permissions";
export const GET_PERMISSION_SETS_URL: string = API_V1_BASE + "/admin/permission-sets";
export const APPLY_PERMISSION_SET_URL: string = API_V1_BASE + "/admin/permission-sets/apply";

// Out of Office
export const GET_OOO_STATUS_URL: string = API_V1_BASE + "/self-service/out-of-office/status";
export const SET_OOO_URL: string = API_V1_BASE + "/self-service/out-of-office";
export const GET_ELIGIBLE_DELEGATES_URL: string = API_V1_BASE + "/self-service/eligible-delegates";
export const GET_OOO_LIST_URL: string = API_V1_BASE + "/self-service/out-of-office/list";
export const ADMIN_SET_OOO_URL: string = API_V1_BASE + "/self-service/out-of-office/admin-set";
export const ADMIN_CANCEL_OOO_URL: string =
  API_V1_BASE + "/self-service/out-of-office/admin-cancel";
export const GET_DELEGATION_LOG_URL: string = API_V1_BASE + "/self-service/delegation-log";

// Notification Settings
export const GET_NOTIFICATION_SETTINGS_URL: string =
  API_V1_BASE + "/self-service/notification-settings";
export const UPDATE_NOTIFICATION_SETTINGS_URL: string =
  API_V1_BASE + "/self-service/notification-settings";
export const GET_TEAM_NOTIFICATION_SETTINGS_URL: string =
  API_V1_BASE + "/self-service/team-notification-settings";
export const UPDATE_TEAM_NOTIFICATION_SETTINGS_URL: string =
  API_V1_BASE + "/self-service/team-notification-settings";

// User management
// G-USERMGMT-01: admin-initiated member actions live on the auth-secondary module (M15). Both POST
// { userId: <member ULID> }; ADMIN_MANAGE_USERS-gated. Email delivery is stubbed until P5 (D5) —
// responses are { sent:false, stub:true, devWelcomeToken? / devTempPassword? } (dev in-response).
export const RESEND_WELCOME_EMAIL_URL: string = API_V1_BASE + "/auth/secondary/resend-welcome";
export const RESET_PASSWORD_URL: string = API_V1_BASE + "/auth/secondary/admin-reset-password";
export const GET_ADMIN_COUNT_URL: string = API_V1_BASE + "/admin/admin-count";

// Hard Delete User
// M12: permanently remove a member -> DELETE /admin/users/:id. Call site appends /:id.
export const HARD_DELETE_TEAM_MEMBER: string = API_V1_BASE + "/admin/users";

// Revalidate Invoice
// Enterprise API: manual re-validation via POST /invoices/:id/revalidate (validation module; no body).
export const REVALIDATE_INVOICE_URL = (id: string | number): string =>
  `${API_V1_BASE}/invoices/${id}/revalidate`;

// Workflow — enterprise engine: approve/reject both POST /workflow/decide { invoiceId, decision, note }.
// (Send-back maps to a REJECTED decision with a note; true non-terminal "send back for rework" is a
// deferred workflow refinement.) Read-lists map to their GET routes.
export const WORKFLOW_APPROVE_URL: string = API_V1_BASE + "/workflow/decide";
export const WORKFLOW_SEND_BACK_URL: string = API_V1_BASE + "/workflow/decide";
// SPRINT-1 export loop: re-fire a failed ERP export (invoice parked EXPORTING after an export
// failure or an EBS import rejection). POST { invoiceId } — INVOICE_EXPORT-gated server-side.
export const WORKFLOW_RETRY_EXPORT_URL: string = API_V1_BASE + "/workflow/retry-export";
export const WORKFLOW_MY_APPROVALS_URL: string = API_V1_BASE + "/workflow/my-approvals";
export const WORKFLOW_MY_HISTORY_URL: string = API_V1_BASE + "/workflow/my-history";
// G-INBOX-01: enterprise per-queue invoice list — call sites append /:queueId/invoices
// (see services/workflowQueueService.ts, which also adapts the response shape).
export const WORKFLOW_INVOICES_BY_QUEUE_URL: string = API_V1_BASE + "/workflow/queues";
export const WORKFLOW_QUEUES_URL: string = API_V1_BASE + "/workflow/queues";
export const WORKFLOW_USER_ASSIGNMENTS_URL: string = API_V1_BASE + "/workflow/my-queues";
// G-INBOX-01: enterprise per-user queue assignments (admin) — call sites append /:userId/queues
// (GET = read a member's assignments, PUT { queueIds } = replace them; ULIDs throughout).
export const WORKFLOW_UPDATE_ASSIGNMENTS_URL: string = API_V1_BASE + "/workflow/users";
export const WORKFLOW_QUEUE_USERS_URL: string = API_V1_BASE + "/workflow/queues"; // + /:id/users at call site

// Budget Holder Routing (M09). Config + threshold-rules are migrated+verified on the C6 API.
// GET config; SAVE config is PUT (see ApprovalRoutingTab). Threshold rules: GET/POST/DELETE/:id.
export const BUDGET_HOLDER_CONFIG_URL: string = API_V1_BASE + "/workflow/budget-holder/config";
export const THRESHOLD_RULES_URL: string = API_V1_BASE + "/workflow/budget-holder/threshold-rules";
// ASSIGNMENTS + PROXIES migrated in M09b. Enriched assignment rows (firstName/lastName/email split +
// ULID userId per M12, segmentDescription via GL_SEGMENT_VALUE per M16, numeric budgetHolderId), and
// proxies now back onto BUDGET_HOLDER_PROXY. Delete is .../assignments/:budgetHolderId (numeric id).
export const BUDGET_HOLDER_ASSIGNMENTS_URL: string =
  API_V1_BASE + "/workflow/budget-holder/assignments";
export const BUDGET_HOLDER_PROXIES_URL: string = API_V1_BASE + "/workflow/budget-holder/proxies";

// JIT Access
export const JIT_REQUEST_URL: string = API_V1_BASE + "/jit/request";
export const JIT_REQUESTS_URL: string = API_V1_BASE + "/jit/requests";
export const JIT_MY_REQUESTS_URL: string = API_V1_BASE + "/jit/my-requests";
export const JIT_APPROVE_URL: string = API_V1_BASE + "/jit/approve";
export const JIT_DENY_URL: string = API_V1_BASE + "/jit/deny";
export const JIT_CANCEL_URL: string = API_V1_BASE + "/jit/cancel";
export const JIT_REVOKE_URL: string = API_V1_BASE + "/jit/revoke";

// Microsoft Teams Integration
// M19 MS Teams — enterprise controller is /ms-teams (settings/status/user-settings). test=net-new.
export const TEAMS_SETTINGS_URL: string = API_V1_BASE + "/ms-teams/settings";
export const TEAMS_STATUS_URL: string = API_V1_BASE + "/ms-teams/status";
export const TEAMS_USER_SETTINGS_URL: string = API_V1_BASE + "/ms-teams/user/settings";
// G-CHATOPS-01: POST connection test — 409 when not connected; stub-honest result when configured.
export const TEAMS_TEST_URL: string = API_V1_BASE + "/ms-teams/test";

// Slack Integration (M19) — /slack settings/status/user-settings. test + oauth callback = net-new.
export const SLACK_SETTINGS_URL: string = API_V1_BASE + "/slack/settings";
export const SLACK_STATUS_URL: string = API_V1_BASE + "/slack/status";
export const SLACK_USER_SETTINGS_URL: string = API_V1_BASE + "/slack/user/settings";
// G-CHATOPS-01: POST connection test — 409 when not connected; stub-honest result when configured.
export const SLACK_TEST_URL: string = API_V1_BASE + "/slack/test";
